






























































































































































import Vue from "vue";
import Component from "vue-class-component";
import func from "@/ts/FormFunctions";
import fieldData from "@/ts/FormData";
import api from "@/ts/functions";
import { IVueStateCollection } from "@/ts/FormBuilder";
import ErrorMessages from "@/ts/constants/ReportingErrorMessages";
import ReportingPeriod from '@/views/reporting/ReportingPeriod.vue';
import VueSimpleSuggest from 'vue-simple-suggest/dist/cjs';
import { IResidentialHaulerVueModel } from "@/ts/models/IResidentialHaulerVueModel";

@Component({
    props: {
        form: {
            type: Object as () => IResidentialHaulerVueModel
        },
        vueStates: {
            type: Object as () => IVueStateCollection
        },
        isReadOnly: {
            type: Boolean
        }
    },
    components: {
        ReportingPeriod, VueSimpleSuggest
    }
})
export default class ResidentialHaulerFacilityInfo extends Vue {
    name: string = "ResidentialHaulerFacilityInfo";
    title: string = "";

    errorMsgs = ErrorMessages;
    toolTipText: string = "Select one region per report. Regions should generally be separated by north, west and south. The listing on page 2 is a suggestion of municipalities to include in each regional report. A hauler may choose to include municipalities listed under a different region when it is reasonable to do so.";
    municipalities = fieldData.municipalities;
    isReportingPeriodError: boolean = false;
    facility: any = null;
    facilities: any = null;
    facilitiesDb: any = null;

    mounted() {
        this.title = this.$props.vueStates.views[0].name;

        this.$emit("update:title", this.title);
        this.$emit("update:currentIndex", 0);

        api.getFacilities("Hauler")
            .then(res => {
                this.facilitiesDb = res;
                this.facilitiesDb = this.facilitiesDb.data;
                this.facilities = this.facilitiesDb.map((f: any) => f.facilityName);
                this.facilities = this.facilities.map(Function.prototype.call, String.prototype.trim);
            });

        this.$watch("hasErrors", (n, o) => {
            this.$props.vueStates.views[0].error = this.hasErrors;
        }, { immediate: true });

        this.$props.vueStates.views[0].visited = true;
    }

    get isHaulerNameError(): boolean {           
        var match: any = null;
        if (this.$props.form.facilityId != null) {
            return false;
        }
        if (this.facilitiesDb != null) {
            match = this.facilitiesDb.filter((f: any) => f.facilityNameSelect === this.$props.form.haulerName);
            if (match.length > 0) {
                var objectId = this.$props.form.haulerName.substring(this.$props.form.haulerName.lastIndexOf('-') + 2);
                this.facility = this.facilitiesDb.find((f: any) => f.objectId == objectId);

                this.$props.form.haulerName = this.facility.facilityName;
                this.$props.form.facilityId = objectId;

                return false;
            } else {
                return true;
            }
        } else {
            return true;
        }        
        //return this.$props.form.haulerName == "" || this.$props.form.haulerName == null;
        //return func.isNullOrEmpty(this.$props.form.haulerName) || match.length == 0;
    }

    get isMunicipalityError(): boolean {
        return func.isNullOrEmpty(this.$props.form.municipality);
    }

    get isHouseholdsError(): boolean {
        return func.isNullOrEmpty(this.$props.form.householdsServiced) || this.$props.form.householdsServiced < 0;
    }
    get isHouseholdsRecyclingError(): boolean {
        return func.isNullOrEmpty(this.$props.form.householdsProvidedRecycling) || this.$props.form.householdsProvidedRecycling < 0;
    }
    get isHouseholdsYardWasteError(): boolean {
        return func.isNullOrEmpty(this.$props.form.householdsProvidedYardWaste) || this.$props.form.householdsProvidedYardWaste < 0;
    }
    get isHaulerError(): boolean {
        return func.isNullOrEmpty(this.$props.form.isHauler)
    }        

    get isReportingYearError(): boolean {
        return this.$props.form.reportingPeriod == null
    }

    get hasErrors(): boolean {
        return this.isHaulerNameError || this.isMunicipalityError || this.isHouseholdsError || this.isReportingPeriodError || this.isHaulerError || this.isReportingYearError;
    }
}
